const ShimmerCard = ({ index, clsName }) => {

    return (
        <div key={index} className={`${clsName} p-2`}>
            <div style={{ borderRadius: "10px" }} className="col-12 bg-white shadow d-flex flex-column justify-content-between p-2 h-100">
                <div>
                    <div className="shadow item-image shine" style={{ borderRadius: "10px", objectFit: "cover" }} />
                    <div style={{
                        fonFamily: "Poppins",
                        fontWeight: 600,
                        textAlign: "left",
                        color: "#000",
                    }}>
                        <div className="p-0 mt-2 mb-0 item-list-title shine" style={{
                            borderRadius: "10px",
                            height: 30,
                            width: "100%"
                        }} ></div>
                        <div className="p-0 mt-0 item-list-extra shine" style={{
                            borderRadius: "10px",
                            fontWeight: 400,
                            height: 10,
                            width: "50%"
                        }} ></div>
                    </div>
                </div>
                <div className="d-flex justify-content-between " style={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    textAlign: "left",
                    color: "#000",
                }}>
                    <div className="my-auto item-list-price shine" style={{ height: 25, width: "35%", borderRadius: "10px", }}></div>
                    <p className="my-auto item-list-extra shine" style={{ height: 20, width: "30%", borderRadius: "10px", }}></p>
                </div>

            </div>
        </div>
    );
}

export default ShimmerCard;